import { lazyGetReadingPaneOptionsSections } from 'owa-mail-ribbon-sections/lib/sections';
import type { MailboxInfo } from 'owa-client-types';
import { setMenuDefinition } from '../../mutatorActions/setMenuDefinition';

export const onReadingPaneOptionsMenuClicked = (mailboxInfo: MailboxInfo): void => {
    lazyGetReadingPaneOptionsSections.import().then(getReadingPaneOptions => {
        setMenuDefinition(
            'ReadingPaneOptionsMenuDefinitionStore',
            undefined /* projectionTabId */,
            () => {
                return {
                    sections: getReadingPaneOptions(mailboxInfo),
                };
            }
        );
    });
};
